import { Box, Button, Group, Image, Loader, Modal, Text } from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconQrcode, IconX } from "@tabler/icons-react";

import { url } from "../settings/linkUrl";
import logo from "../assets/promptpay.png";
import "./AppModelQrCode.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import QRCode from "react-qr-code";

interface RowDataUser {
  id: string;
  url: string;
  faculty: string;
  programe: string;
  short_name: string;
  name: string;
  role: string;
  number_true: string;
  creck: string;
  vut: string;
  type_std_name: string;
  ref1: string;
  ref2: string;
  amount: string;
  dateexpried: string;
}

interface RowMoney {
  payment_ref1: any;
  payment_ref2: any;
  payment_money: any;
  barcode: any;
  barcodeP: any;
  payment_timeout: any;
}

export default function AppModelQrCode({
  payment_ref1,
  payment_ref2,
  payment_money,
  barcode,
  barcodeP,
  payment_timeout,
}: RowMoney) {
  const nav = useNavigate();
  const [abortController, setAbortController] = useState<AbortController | null>(null);

  const [opened, { open, close }] = useDisclosure(false);
  const [dataUser, SetdataUser] = useState<RowDataUser>();

  const [useApi, setUseApi] = useState(true);

  const LoadPage = async () => {
    const controller = new AbortController();
    setAbortController(controller);

    let rr: any = localStorage.getItem("dataUser");
    SetdataUser(JSON.parse(rr));

    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      signal: controller.signal, // <-- ใช้ signal
    };

    try {
      const response = await fetch(`${url}register/checkconfirm_money`, requestOptions);
      if (!response.ok) throw Error(response.statusText);
      const json = await response.json();

      if (json.data.success === "1") {
        nav("/dashboard");
        close();
      } else {
        LoadPage(); // รีโหลดซ้ำ ถ้าไม่สำเร็จ
      }
    } catch (error: any) {
      if (error.name !== "AbortError") {
        LoadPage(); // รีโหลดซ้ำ ถ้าไม่ใช่การยกเลิก
      }
    }
  };

  useEffect(() => {
    return () => {
      abortController?.abort(); // cleanup เมื่อ unmount
    };
  }, [abortController]);

  const onCloseModal = () => {
    close();
    abortController?.abort(); // ยกเลิก fetch
  };

  const onOpenModal = async () => {
      open();
      LoadPage();
  }

  return (
    <>
      <Modal
        opened={opened}
        onClose={onCloseModal}
        size="md"
        centered
        title="ชำระเงิน"
        transitionProps={{
          transition: "fade",
          duration: 300,
          timingFunction: "linear",
        }}
      >
        <div className="logo">
          <Image src={logo} w={180} />
          <div className="promtpay-detail">
            <h1>บัญชีพร้อมเพย์</h1>
            <h1>80096 : ชำระค่าลงทะเบียนซ้อมรับพระราชทานปริญญาบัตร</h1>
          </div>
          <QRCode value={barcode} level="H" />
          <h1>ref 1 : {payment_ref1}</h1>
          <h1>ref 2 : {payment_ref2}</h1>
          <h2>จำนวนเงิน {payment_money} บาท</h2>
          <br />
          <div className="loader"></div>
          <Loader />
          <h3>waiting...</h3>
          <h4>จะหมดอายุในวันที่ {payment_timeout} เวลา 24:00 น.</h4>
        </div>
      </Modal>
      <Button
        leftSection={<IconQrcode />}
        variant="gradient"
        gradient={{ from: "indigo", to: "cyan" }}
        onClick={onOpenModal}
      >
        ชำระเงินผ่าน Qr Code จำนวน {payment_money} บาท
      </Button>
    </>
  );
}
